import { Component, OnInit, Input } from '@angular/core';
import { ProjectSetupDto, SummaryStageDto } from "../../data/CommandServiceDtos.generated";

@Component({
  selector: 'project-execution-stage',
  templateUrl: './project-execution-stage.component.html',
  styleUrls: ['./project-execution-stage.component.scss']
})
export class ProjectExecutionStageComponent implements OnInit {
  @Input() stage: SummaryStageDto;
  @Input() project: ProjectSetupDto = new ProjectSetupDto;

  projectActivityDisplayType: string = "";
  constructor() { }

  ngOnInit() {
    console.clear();
    console.log(this.project)
    this.projectActivityDisplayType = this.project.ActivitiesDisplayType;
  }

  showPercentage(type) {
    console.log(this.projectActivityDisplayType && this.projectActivityDisplayType != undefined ? this.projectActivityDisplayType.includes(type) : false);
    return this.projectActivityDisplayType && this.projectActivityDisplayType != undefined ? this.projectActivityDisplayType.includes(type) : false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/project-execution-stage/project-execution-stage.component.ts